import { useCallback } from 'react';

import { useSelector } from 'react-redux';
import selectors from '../selectors/selectors.js';

export const useGetUtmMediumOrUtmSourceName = () => {
  const utmMediums = useSelector((state) => state.app.utm_mediums);
  const utmSources = useSelector(selectors.utmSources);
  const getUtmMediumOrUtmSourceName = useCallback(
    (data, type) => {
      const searchValue = type === 'source' ? utmSources : utmMediums;
      const final = searchValue.find((item) => item.value === data || item.name === data);
      return (final || {}).value ? (final || {}).value : null;
    },
    [utmMediums, utmSources]
  );

  return { getUtmMediumOrUtmSourceName };
};
